import { IconProps } from "@/data/types"

export default function RulerIcon({ width=32, height=32, color='#000000', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" strokeWidth="1.92" stroke={color} fill="none">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <rect x="8.5" y="9.25" width="10.68" height="45.49" rx=".2" strokeLinecap="round"></rect>
          <line x1="8.5" y1="14.26" x2="12.3" y2="14.26" strokeLinecap="square"></line>
          <line x1="8.5" y1="19.38" x2="12.3" y2="19.38" strokeLinecap="square"></line>
          <line x1="8.5" y1="24.51" x2="12.3" y2="24.51" strokeLinecap="square"></line>
          <line x1="8.5" y1="29.64" x2="12.3" y2="29.64" strokeLinecap="square"></line>
          <line x1="8.5" y1="34.77" x2="12.3" y2="34.77" strokeLinecap="square"></line>
          <line x1="8.5" y1="39.72" x2="12.3" y2="39.72" strokeLinecap="square"></line>
          <line x1="8.5" y1="44.66" x2="12.3" y2="44.66" strokeLinecap="square"></line>
          <line x1="8.5" y1="49.61" x2="12.3" y2="49.61" strokeLinecap="square"></line>
          <path d="M24.16,9.83V54.57a.19.19,0,0,0,.18.18h31a.19.19,0,0,0,.15-.29l-31-44.73A.18.18,0,0,0,24.16,9.83Z" strokeLinecap="round"></path>
          <path d="M29.38,26.48V49.19a.09.09,0,0,0,.08.08H44.63a.2.2,0,0,0,.16-.31L29.53,26.43A.08.08,0,0,0,29.38,26.48Z" strokeLinecap="round"></path>
        </g>
      </svg>
    </div>
  )
}